jQuery(document).ready(function ($) {
    var $window = $(window),
        html = $("html"),
        body = $("body"),
        header = $("header"),
        article = $("article"),
        footer = $("footer");
    ({
        init: function () {
            this.get_fade_product();
            this.get_istope();
            this.get_lazy(),
            this.menu_has_subpage();
            this.menu_toggle();
            this.scroll_shrink(),
            this.popup_toggle(),
            this.scrollto(),
            this.padding_top_head(),
            this.text_lettering(),
            this.get_action_share(),
            this.scroll_stick_header(),
            this.get_search(),
            this.getFancybox(),
            this.load(),
            this.resize(),
            this.overlay_load();
        },
        get_fade_product: function(){
            $.each($(".product-main .card-item"), function(i, el){
                $(el).css("opacity","0");
                setTimeout(function(){
                    $(el).css("opacity","1");
                },500 + ( i * 300 ));
            });
        },
        get_istope: function(){
            if($(".galllery-grid").length){
                $(".galllery-grid").isotope({
                    filter: "*",
                    animationOptions: {
                        duration: 750,
                        easing: "linear",
                        queue: !1
                    }
                })
            }
        },
        menu_has_subpage: function(){
            var submenu = $('.submenu');
            if(submenu.length){
                submenu.each(function(){
                    $(this).parent().addClass('has-sub');
                });
            }
        },
        menu_toggle: function(){
            $('.toggle-menu').click(function(){
                console.log('ddd');
                $(this).parents('.page-wrapper').find('.header-menu').toggleClass('active');
            });
        },
        overlay_load: function () {
            $("#overlay-load").fadeOut()
        },
        get_lazy: function () {
            if ($(".lazy").length) {
                $(".lazy").lazy()
            }
        },
        text_lettering: function () {
            if ($(".text-lettering").length) {
                $(".text-lettering").lettering();
            }
        },
        padding_top_head: function () {
            var t = $(".padding-top-head"),
                i = header.outerHeight();
            t.css("padding-top", i);

            $('.page-container').css("padding-top", i);
        },
        scroll_shrink: function () {
            var t = this;
            $window.height();
            $(window).scroll(function () {
                var i = window.pageYOffset;
                i >= 400 ? body.addClass("shrink-2") : body.removeClass("shrink-2");
                i >= 200 ? body.addClass("shrink") : body.removeClass("shrink");
            })

        },
        scrollto: function () {
            $(".scrollto").click(function () {
                var t = $(this).attr("data-pos");
                if (void 0 === t) {
                    var i = $(this).attr("data-id");
                    $("#" + i).length && $("html,body").animate({
                        scrollTop: $("#" + i).offset().top
                    }, 500)
                } else "" != t && $("html,body").animate({
                    scrollTop: parseInt(t)
                }, 500);
                return !1
            }), $('a[href^="#"]').click(function () {
                var t = $(this).attr("href");
                if ($(t).length) return $("html,body").animate({
                    scrollTop: $(t).offset().top
                }, 500), !1
            })
        },
        popup_toggle: function () {
            $(".toggle-pop").click(function () {
                var t = $(this).attr("data-pop"),
                    i = $("#" + t);
                $(this).toggleClass("active"), i.each(function () {
                    "fade" == $(this).attr("data-action") ? $(this).fadeToggle() : "slide" == $(this).attr("data-action") && $(this).stop(!0, !0).slideToggle(), $(this).toggleClass("active")
                });
                i.find('input').focus();
                return false;
            })
        },
        get_action_share: function () {
            var self = this;
            var _this = {
                button_click: function () {
                    var btn = $(".js-social-share");
                    btn.click(function () {
                        self.windowPopup($(this).attr("href"), 500, 500);
                        return false;
                    })
                },

            }
            _this.button_click();
        },
        windowPopup: function (url, width, height) {
            var left = (window.screen.availLeft + (window.screen.availWidth / 2)) - (width / 2);
            var top = (window.screen.availTop + (window.screen.availHeight / 2)) - (height / 2);
            window.open(url, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
        },
        scroll_stick_header: function () {
            // var ele = $('.ele-white');
            // var body = $('body');
            // if(ele.length){
            //     $(window).scroll(function() {
            //         var scroll = $(window).scrollTop();
            //         var et = ele.offset().top; 
            //         var eh = ele.height();
            //         if(scroll > et && scroll <  (et +eh ) ) body.addClass('header--white');
            //         else body.removeClass('header--white');  
            //     });
            // }
            $(window).scroll(function() {    
                var scroll = $(window).scrollTop();
                if (scroll >= 10) {
                    $(".gh-header").addClass("header_scroll");
                } else {
                    $(".gh-header").removeClass("header_scroll");
                }
            });
        },
        get_search:function(){
            $( "#search" ).click(function() {
                $('#get_search form').toggleClass('show');
            });
        },
        getFancybox:function(){
            if( $("a[data-fancybox]").length){
                $("a[data-fancybox]").fancybox({
                    infobar: false,
                    loop : true,
                    btnTpl: {
                        close:
                        '<button data-fancybox-close class="fancybox-btn fancybox-btn--close" title="{{CLOSE}}">' +
                        'close' +
                        "</button>",
                        arrowLeft:
                        '<a data-fancybox-prev class="fancybox-button fancybox-button--arrow fancybox-button--arrow_left" title="{{PREV}}" href="javascript:;">' +
                        '<i class="icomoon-arrow"></i>' +
                        "</a>",
                
                      arrowRight:
                        '<a data-fancybox-next class="fancybox-button fancybox-button--arrow fancybox-button--arrow_right" title="{{NEXT}}" href="javascript:;">' +
                        '<i class="icomoon-arrow"></i>' +
                        "</a>"
                    }
                });
            }
            
        },
        load: function () {
            var t = this;
            $window.load(function () {
                t.get_istope();
                $("*[data-enllax-type]").length && $window.width() > 767 && $(window).enllax();
            })
        },
        resize: function () {
            var t = this;
            $window.resize(function () {
                t.padding_top_head();
            })
        }
    }).init()
});